import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import nakasendoCut2Preview from '../assets/images/Nakasendo_preview_cut2.png';
import './ActionsBar.css';

const NAKASENDO_VIDEO = 'https://firebasestorage.googleapis.com/v0/b/mythic-maps.firebasestorage.app/o/assets%2FNakasendo_cut2_square.mp4?alt=media';

const ActionsBar = () => {
  const { t } = useTranslation();
  const videoContainerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );

    if (videoContainerRef.current) {
      observer.observe(videoContainerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <Link to="/challenge" className="challenge-banner">
      <div className="challenge-banner-header">
        <div className="challenge-banner-text">
          <span className="challenge-banner-title">
            {t('actionsBar.challengeTitle', '8 legendary routes, across every continent.')}
          </span>
          <span className="challenge-banner-description">
            {t('actionsBar.challengeDescription', 'From the Nakasendo to the Annapurna Circuit. Your runs, walks, and rides move you along the route. Unlock stunning artwork at every checkpoint.')}
          </span>
        </div>
        <span className="challenge-banner-badge">
          {t('actionsBar.challengeCta', 'Explore')}
        </span>
      </div>
      <div className="challenge-banner-video" ref={videoContainerRef}>
        {isVisible ? (
          <video
            src={NAKASENDO_VIDEO}
            autoPlay
            muted
            loop
            playsInline
            preload="none"
            poster={nakasendoCut2Preview}
            className="challenge-banner-video-el"
          />
        ) : (
          <img
            src={nakasendoCut2Preview}
            alt=""
            className="challenge-banner-video-el"
          />
        )}
      </div>
    </Link>
  );
};

export default ActionsBar;
